export class AppConsts {
    public static AdminContext: string = 'admin';
    public static Session_Lang: string = 'lang';
    public static Session_AccessToken: string = 'access_token';
    public static Session_RefreshToken: string = 'refresh_token';
    public static Session_ForceChangePassword: string = 'force-change-password';
    public static Session_Permissions: string = 'permissions';
    public static Session_ExpiresAt: string = 'expires_at';
    public static Session_PaymentUrl: string = 'paymentUrl';
    public static Session_PaymentLang: string = 'paymentLang';
    public static Session_IsGranted: string = 'isGranted';
}